<template>
    <div>
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover;" :style="{ backgroundImage: `url(${backgroundUrl})` }">
            <CCol sm="12" lg="12">
                <CRow>
                    <CCol sm="12" lg="12" class="mb-5">
                        <div style="margin-top: 10%">
                            <CCol sm="12" style="width: 50%;background-size: cover; margin: auto;" class="d-sm-down-none">
                               
                                <CCard class="border-radius-16px p-4 m-1" v-if="showMain ===true">
                                    <div v-if="this.ErrorMessage == true" class="ml-4 mr-4 mt-4">
                                                <CAlert show color="danger">
                                                    <strong class="text-danger mr-2">Error !</strong> Phone is required.Please fill the form following below.
                                                </CAlert>
                                            </div>
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-left font-color-171717">Select your Country </h3>
                                        <p class="custom-16px-400 text-left">Already have an account? Log in to access your profile, preferences, and saved progress.</p>
                                    </div>
                                    <div class="search-container mb-2">
                                        <input v-model="phone" type="text" placeholder="Enter your phone" class="custom-input-app-form border-radius-16px" />
                                    </div>
                                    <div class="search-container mb-3">
                                        <input v-model="searchQuery" type="text" placeholder="Search countries..." class="custom-input-app-form border-radius-16px" />
                                    </div>
                                    <div class="custom-scroll-countries">
                                        <CCard class="border-radius-16px" v-for="item in filteredCountries" v-bind:key="item.Id">
                                            <CRow class="m-2">
                                                <CCol sm="1">
                                                    <img v-if="item.PictureUrl" :src="item.PictureUrl" style="max-width:32px" alt="Country Flag"/>
                                                </CCol>
                                                <CCol sm="10">
                                                    <h3 class="custom-14px-500">{{ item.CountryName }}</h3>
                                                </CCol>
                                                <CCol sm="1">
                                                    <input type="radio" :value="item.Id" v-model="selectedCountries" class="mt-2" />
                                                </CCol>
                                            </CRow>
                                        </CCard>
                                    </div>
    
    
                                    <div class="text-center mt-5 mb-2">
                                        <CButton class="custom-border-purple text-white text-center" @click="OpenContinue()">Continue</CButton>
                                    </div>
                                </CCard>
    
                                <CCard class="border-radius-16px p-4 mb-5" v-if="showSelectionType ===true">
                                    <div class="text-center">
                                        <h3 class="custom-32px-500 text-left font-color-171717 text-center mb-5 mt-5">Account Type Selection </h3>
                                    </div>
    
                                    <CRow>
                                        <CCol sm="6">
                                            <div class="text-center selection-option" :class="{ selected: selectedType === 'individual' }" @click="selectType('individual')">
                                                <img style="max-width:56px" src="../assets/img/userselect.png" />
                                                <h3 class="custom-20px-600 mt-3 font-color-928AFD">
                                                    Candidate
                                                </h3>
                                                <p class="custom-18px-400 font-color-696969">
                                                    <label class="font-color-696969">
                            Practice with AI, Enhance <br />
                            Your Abilities, and Boost <br />
                            Your Career Profile
                          </label>
                                                </p>
                                            </div>
                                        </CCol>
                                        <CCol sm="6">
                                            <div class="text-center selection-option" :class="{ selected: selectedType === 'company' }" @click="selectType('company')">
                                                <img style="max-width:56px" src="../assets/img/company.png" />
                                                <h3 class="custom-20px-600 mt-3 font-color-928AFD">
                                                    Company
                                                </h3>
                                                <p class="custom-18px-400 font-color-696969">
                                                    <label class="font-color-696969 mt-1">
                            Review Candidate Interviews, <br />
                            Streamline Recruitment, and <br />
                            Optimize Hiring Decisions
                          </label>
                                                </p>
                                            </div>
                                        </CCol>
                                    </CRow>
    
                                    <div v-if="showError" class="text-center text-danger mt-2">
  <CAlert color="danger">Please select either Candidate or Company.</CAlert>
</div>
                                    <div class="text-center mt-5 mb-5">
                                        <CButton class="custom-border-purple text-white text-center" @click="OpenCreateAccount()">Continue</CButton>
                                    </div>
                                </CCard>
                            </CCol>


                            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;" class="d-md-none">
                               
                               <CCard class="border-radius-16px p-4 m-1" v-if="showMain ===true">
                                   <div v-if="this.ErrorMessage == true" class="ml-4 mr-4 mt-4">
                                               <CAlert show color="danger">
                                                   <strong class="text-danger mr-2">Error !</strong> Phone is required.Please fill the form following below.
                                               </CAlert>
                                           </div>
                                   <div class="text-center">
                                       <h3 class="custom-32px-500 text-left font-color-171717">Select your Country </h3>
                                       <p class="custom-16px-400 text-left">Already have an account? Log in to access your profile, preferences, and saved progress.</p>
                                   </div>
                                   <div class="search-container mb-2">
                                       <input v-model="phone" type="text" placeholder="Enter your phone" class="custom-input-app-form border-radius-16px" />
                                   </div>
                                   <div class="search-container mb-3">
                                       <input v-model="searchQuery" type="text" placeholder="Search countries..." class="custom-input-app-form border-radius-16px" />
                                   </div>
                                   <div class="custom-scroll-countries">
                                       <CCard class="border-radius-16px" v-for="item in filteredCountries" v-bind:key="item.Id">
                                           <CRow class="m-2">
                                               <CCol sm="1">
                                                   <img v-if="item.PictureUrl" :src="item.PictureUrl" style="max-width:32px" alt="Country Flag"/>
                                               </CCol>
                                               <CCol sm="10">
                                                   <h3 class="custom-14px-500">{{ item.CountryName }}</h3>
                                               </CCol>
                                               <CCol sm="1">
                                                   <input type="radio" :value="item.Id" v-model="selectedCountries" class="mt-2" />
                                               </CCol>
                                           </CRow>
                                       </CCard>
                                   </div>
   
                                  
                                   <div class="text-center mt-5 mb-2">
                                       <CButton class="custom-border-purple text-white text-center" @click="OpenContinue()">Continue</CButton>
                                   </div>
                               </CCard>
   
                               <CCard class="border-radius-16px p-4 mb-5" v-if="showSelectionType ===true">
                                   <div class="text-center">
                                       <h3 class="custom-32px-500 text-left font-color-171717 text-center mb-5 mt-5">Account Type Selection </h3>
                                   </div>
   
                                   <CRow>
                                       <CCol sm="6">
                                           <div class="text-center selection-option" :class="{ selected: selectedType === 'individual' }" @click="selectType('individual')">
                                               <img style="max-width:56px" src="../assets/img/userselect.png" />
                                               <h3 class="custom-20px-600 mt-3 font-color-928AFD">
                                                   Candidate
                                               </h3>
                                               <p class="custom-18px-400 font-color-696969">
                                                   <label class="font-color-696969">
                           Practice with AI, Enhance <br />
                           Your Abilities, and Boost <br />
                           Your Career Profile
                         </label>
                                               </p>
                                           </div>
                                       </CCol>
                                       <CCol sm="6">
                                           <div class="text-center selection-option" :class="{ selected: selectedType === 'company' }" @click="selectType('company')">
                                               <img style="max-width:56px" src="../assets/img/company.png" />
                                               <h3 class="custom-20px-600 mt-3 font-color-928AFD">
                                                   Company
                                               </h3>
                                               <p class="custom-18px-400 font-color-696969">
                                                   <label class="font-color-696969 mt-1">
                           Review Candidate Interviews, <br />
                           Streamline Recruitment, and <br />
                           Optimize Hiring Decisions
                         </label>
                                               </p>
                                           </div>
                                       </CCol>
                                   </CRow>
   
                                   <div v-if="showError" class="text-center text-danger mt-2">
  <CAlert color="danger">Please select either Candidate or Company.</CAlert>
</div>
                                   <div class="text-center mt-5 mb-5">
                                       <CButton class="custom-border-purple text-white text-center" @click="OpenCreateAccount()">Continue</CButton>
                                   </div>
                               </CCard>
                           </CCol>
                        </div>
                    </CCol>
    
                </CRow>
            </CCol>
        </CCol>
    
        <div v-if="isPopupVisible" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
    
                    <CRow>
                        <CCol sm="6"></CCol>
                        <CCol sm="6"></CCol>
                    </CRow>
                    <CButton class="custom-border-purple text-white" @click="closePopup"><span class="ml-2 mr-2">OK</span></CButton>
                </div>
    
            </div>
        </div>
    
    
    </div>
</template>


<script>
import Vue from "vue";

import GAuth from 'vue-google-oauth2'

const gauthOption = {
    clientId: '1076578801027-kt1ptr3hd1ou78tlj65vmfaj8tgafq72.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
}

Vue.use(GAuth, gauthOption)

import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeaderBlack.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundUrNoArrow,

            backgroundGenie,
            countries: [],
            selectedCountries: "",

            isPopupVisible: false,
            showMain: true,
            showSelectionType: false,
            selectedType: 'individual',
            searchQuery: '',
            phone: '',
            ErrorMessage: false,
            showError: false,

        };
    },
    computed: {
        filteredCountries() {
            return this.countries.filter((country) =>
                country.CountryName.toLowerCase().includes(this.searchQuery.toLowerCase())
            );
        },
    },
    mounted() {
        this.GetListCountries();
    },
    methods: {
        async GetListCountries() {
            try {
                const response = await this.$API.get(this.$GetListCountries);
                if (response.status === 200) {
                    this.countries = response.data;
                } else {}
            } catch (error) {}
        },
        OpenContinue() {
            if(this.phone === '')
            {
                this.ErrorMessage = true;
            }
            else{
                this.showMain = false;
            this.showSelectionType = true;
            }
           
        },
        OpenCreateAccount() {
           
            if (this.selectedType) {
                this.$router.push({ path: 'SignUp', query: { type: this.selectedType, countryid: this.selectedCountries, phone: this.phone, email: this.$route.query.email } });
            } else {
                // Handle the case where no type is selected
                this.showError = true;
                console.error('No type selected');
            }
        },
        selectType(type) {
            this.selectedType = type; // Set the selected type
        },
        


    },

};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.selection-option {
    cursor: pointer;
    border: 2px solid transparent;
    /* Default border color */
    padding: 10px;
    border-radius: 5px;
    transition: border-color 0.3s;
}

.selection-option.selected {
    border-color: #928afd;
    /* Highlight color when selected */
    background-color: #f0f0f5;
    /* Optional background color for selected state */
}
</style>